import { useEffect, useState } from "react";
import ReassignQC from "../../../../../Modal/ReassignQC";
import globalRequest from "../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import { checkPermissionAction } from "../../../../../utils/helper/utils";
import { useTranslation } from "../../../../../context/TranslationContext";

const QcDetails = ({
  qcData,
  qcRequestData,
  orderDetailData,
  reloadPage,
  permissionJson,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [allQc, setAllQc] = useState({});
  const [isReassignQCModalOpen, setIsReassignQCModalOpen] = useState(false);
  const [selectedQc, setSelectedQc] = useState(0);
  const showReassignQCModal = () => {
    setIsReassignQCModalOpen(true);
  };

  const handleReassignQCOk = async () => {
    let insertData = {
      order_id: orderDetailData.id,
      qc_id: selectedQc,
    };

    if (selectedQc === 0) {
      toast.error("Qc is requried.");
      return false;
    }

    dispatch(changeLoader(true));
    try {
      let url = Apis?.ORDERS?.ASSIGN_TO_QC;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Qc assign successfully";
        toast.success(msg, {
          duration: 2000,
        });
        setIsReassignQCModalOpen(false);
        reloadPage();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };
  const handleReassignQCCancel = () => {
    setIsReassignQCModalOpen(false);
  };

  const getAllQc = async () => {
    try {
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_QC,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        let data = apiResponse?.data?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.firstName + " " + item?.lastName,
          };
        });
        setAllQc(data || []);
      } else setAllQc([]);
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getAllQc();
  }, []);

  return (
    <>
      <div className="px-9 py-5  border-gray-250 border-b w-full ">
        <h2 className="font-semibold text-base mb-3">{t("qcDetail")}</h2>
        <div className="flex">
          {Object.keys(qcData).length !== 0 ? (
            <img
              src="images/user-profile.png"
              alt="user-thumbnail"
              className="w-[24px] h-[24px] rounded"
            />
          ) : null}
          <div className="pl-2">
            {Object.keys(qcData).length !== 0 ? (
              <>
                <h3 className="text-sm font-semibold">
                  {qcData.firstName} {qcData.lastName}
                </h3>
                {orderDetailData.qcStatus === "pending" ? (
                  checkPermissionAction(
                    "Order Management",
                    permissionJson,
                    "assign_qc"
                  ) ? (
                    <h2
                      className="underline text-base my-2 cursor-pointer"
                      onClick={showReassignQCModal}
                    >
                      {t("reassignQc")}
                    </h2>
                  ) : null
                ) : null}
              </>
            ) : (
              <>
                {checkPermissionAction(
                  "Order Management",
                  permissionJson,
                  "assign_qc"
                ) ? (
                  <h2
                    className="underline text-base my-2 cursor-pointer"
                    onClick={showReassignQCModal}
                  >
                    {t("assignQc")}
                  </h2>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
      {isReassignQCModalOpen && (
        <ReassignQC
          isOpen={isReassignQCModalOpen}
          onOk={handleReassignQCOk}
          onCancel={handleReassignQCCancel}
          allQc={allQc}
          props={{ setSelectedQc, selectedQc }}
        />
      )}
    </>
  );
};
export default QcDetails;
